import React from "react";
import { Box, Heading, IconTick, Span } from "@catchoftheday/cg-components";
import { BenefitItemZone } from "../../layouts/UpsellModalLayout/UpsellModalLayout";
export const BENEFIT_ITEMS = [
    `Free delivery on eligible products or orders at all OnePass retail brands`,
    `Member-only pricing on thousands of products at Catch`,
    `Access to weekly exclusive member deals at Catch`,
];
export const BenefitItem = ({ children }) => (<BenefitItemZone>
    <Box alignSelf="center">
      <IconTick width="1.25em" mr={2} color="inherit"/>
    </Box>
    <Span fontSize="inherit" fontWeight="medium">
      {children}
    </Span>
  </BenefitItemZone>);
export const Benefits = () => (<>
    <Heading.h3 fontWeight="bold" textTransform="capitalize" m={0}>
      OnePass Member Benefits:
    </Heading.h3>
    <Box mb={6}>
      {BENEFIT_ITEMS.map((text, index) => (<BenefitItem key={`upsell-modal-benefit-${index}`}>{text}</BenefitItem>))}
    </Box>
  </>);
